import React, { ReactElement } from 'react';
import { Attribute } from '@services';
import classnames from 'classnames/bind';
import styles from './ProductDetail.module.scss';
import parse from 'html-react-parser';
import { List } from 'gd-design-library';

const CN = 'product-detail';
const productDetailText= `${CN}__text`;
const productDetailLabel = `${CN}__label`;

const cx = classnames.bind(styles);

const renderAttributeValue = (attribute: Attribute): ReactElement | null => {
  switch (attribute.type) {
  case 'text': {
    if (Array.isArray(attribute.value)) {
      return <List
        variant='unordered-dot'
        items={ attribute.value.map(item => parse(item)) }
        style={ { marginTop: '0.5rem' } }
      />;
    } else {
      return <span className={ cx(productDetailText) }>{parse(attribute.value)}</span>;
    }
  }
  case 'boolean':
    return <span className={ cx(productDetailText) }>{attribute.value ? 'Yes' : 'No'}</span>;
  default:
    return null;
  }
};

export const ProductDetail: React.FC<{ attribute: Attribute }> = ({ attribute }) => (
  <div className={ cx(CN) }>
    <span className={ cx(productDetailLabel) }>{attribute.label || attribute.name}: </span>
    {renderAttributeValue(attribute)}
  </div>
);
